import { CalendarMonth, Cancel, CheckCircle, Info, Schedule, Warning } from '@mui/icons-material';
import { Chip, type ChipProps } from '@mui/material';
import React from 'react';

export type StatusType = 'success' | 'pending' | 'error' | 'warning' | 'info' | 'upcoming';

interface StatusChipProps extends Omit<ChipProps, 'color'> {
    status: StatusType;
}

const STATUS_CONFIG = {
    success: CheckCircle,
    pending: Warning,
    error: Cancel,
    warning: Warning,
    info: Info,
    upcoming: Schedule,
};

export default function StatusChip({ status, label, ...props }: StatusChipProps) {
    const IconComponent = STATUS_CONFIG[status];
    const className = `status-chip-${status}`;

    return <Chip icon={<IconComponent />} label={label} className={className} size="small" {...props} />;
}
